<template>
  <div id="lastLoginInformation_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            最後登入使用者資訊
          </div>
        </div>
      </div>
      <div v-if="data === null">
        無資料
      </div>
      <div v-else>
        <div
          v-for="( item, index ) in data"
          :key="index"
        >
          <div
            :id="index"
            :value="item"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <FooterFrame />
  </div>
</template>
<script>
import FooterFrame from '@/components/FooterFrame'

export default {
  components: {
    FooterFrame
  },
  data () {
    return {
      data: null
    }
  },
  mounted () {
    if (localStorage.getItem('loginUserInfo')) {
      this.data = JSON.parse(localStorage.getItem('loginUserInfo'))
      this.data.DueTime = this.$newFormatDate(new Date(this.data.ExpireTime))
      console.log(this.data)
    }
  }
}
</script>

<style lang="sass" scoped>
#lastLoginInformation_main
  +mainLayer
  text-align: left
  line-height: 30px
  font-size: 18px
</style>
